import { ThemePalette } from "@/core/theme";

export const palette: ThemePalette = {
  P1: {
    $300: '#F1E6CD',
    $400: '#E4D4AE',
    $500: '#DCC596',
    $600: '#CBB27C',
    $700: '#C5A96D',
    $800: '#B19862',
    $900: '#9E8757',
    $1000: '#8A764C',
  },
  P2: {
    $300: '#F2D6D7',
    $400: '#E4A9AB',
    $500: '#D27174',
    $600: '#C9464A',
    $700: '#9E0B0F',
    $800: '#8E0A0E',
    $900: '#7E090C',
    $1000: '#6F080B',
  },
  Black: {
    $300: '#F0F0F0',
    $400: '#E5E5E5',
    $500: '#D8D8D8',
    $600: '#CCCCCC',
    $700: '#999999',
    $800: '#666666',
    $900: '#333333',
    $1000: '#000000',
  },
  White: {
    $700: '#FFFFFF',
    $800: '#E8EBEE',
    $900: '#DEE3E7',
    $1000: '#CDD4DB',
  },
  Green: {
    $100: '#E8F5E9',
    $200: '#C8E6C9',
    $300: '#A5D6A7',
    $400: '#81C784',
    $500: '#66BB6A',
    $600: '#4CAF50',
    $700: '#43A047',
    $800: '#388E3C',
    $900: '#2E7D32',
    $1000: '#1B5E20',
  },
  Orange: {
    $100: '#FBE9E7',
    $200: '#FFCCBC',
    $300: '#FFAB91',
    $400: '#FF8A65',
    $500: '#FF7043',
    $600: '#FF5722',
    $700: '#F4511E',
    $800: '#E64A19',
    $900: '#D84315',
    $1000: '#BF360C',
  },
  Red: {
    $100: '#FFEBEE',
    $200: '#FFCDD2',
    $300: '#EF9A9A',
    $400: '#E57373',
    $500: '#EF5350',
    $600: '#F44336',
    $700: '#E53935',
    $800: '#D32F2F',
    $900: '#C62828',
    $1000: '#B71C1C',
  },
  Dark: {
    $50: '#FAFAFA',
    $100: '#F5F5F5',
    $200: '#EEEEEE',
    $300: '#E0E0E0',
    $400: '#BDBDBD',
    $500: '#9E9E9E',
    $600: '#757575',
    $700: '#4A4A4A',
    $800: '#2D2D2D',
    $900: '#252525',
    $1000: '#1A1A1A',
  },
  Background: {
    LIGHT_BLUE_BG: '#E0FFFD',
    BLUE_BG: '#E6F7FF',
    GRAY: '#666666',
    YELLOW_BG: '#FFF7D4',
    LIGHT_BLUE: '#08979C',
    BLUE: '#096DD9',
  }
}
